import { useFetchProfile } from 'hooks/useConnectedUsers';
import Cookies from 'js-cookie';
import { paths } from 'pages/routes';
import React, { PropsWithChildren, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import userSelectors from 'store/user/selectors';
import teamSelectors from 'store/team/selectors';

export const AuthenticatedLayout: React.FC<PropsWithChildren<unknown>> = ({ children }) => {
    const connected = useSelector(userSelectors.selectIsConnected);
    const myTeam = useSelector(teamSelectors.selectMyTeam);
    const token = Cookies.get(process.env.REACT_APP_JWT_PATH || 'jwt_token');
    const history = useHistory();
    const { refetch } = useFetchProfile();

    useEffect(() => {
        if (!connected && !token) {
            history.push(paths.user.USER_LOGIN);
        }
        if (token && (!connected || !myTeam)) {
            // noinspection JSIgnoredPromiseFromCall
            refetch();
        }
    }, [connected, myTeam, history, token]);

    return <>{children}</>;
};
